import { getTurnCredentials } from "./turn";

export const peerConfiguration = () => {
    const turnCredentials = getTurnCredentials();

    const iceServers = [
        { urls: 'stun:stun.l.google.com:19302' },
        ...(turnCredentials || []),
    ];

    const maxIceServers = 4;

    const uniqueIceServers = Array.from(
        new Map(iceServers.map((server) => [server.urls, server])).values()
    ).slice(0, maxIceServers);

    return { iceServers: uniqueIceServers };
};